// extracted by mini-css-extract-plugin
export var actionButton = "_bg-1";
export var actionButtons = "_bg-2";
export var actions = "_bg-0";
export var aiUnread = "_bg-10";
export var alignCenter = "_bg-h";
export var backWrapper = "_bg-3";
export var cellContainer = "_bg-4";
export var checkboxContainer = "_bg-5";
export var contentContainer = "_bg-6";
export var contentHeader = "_bg-8";
export var conversationsTableWrapper = "_bg-s";
export var draftReplyBadgeContainer = "_bg-m";
export var dropdownItem = "_bg-b";
export var dropdownItemsContainer = "_bg-a";
export var dropdownTitle = "_bg-c";
export var errorIcon = "_bg-7";
export var filter = "_bg-d";
export var gray = "_bg-i";
export var headerActionButtons = "_bg-e";
export var headerCheckboxContainer = "_bg-f";
export var icon = "_bg-j";
export var menuContainer = "_bg-k";
export var noMoreTicketsIcon = "_bg-12";
export var noMoreTicketsSubText = "_bg-13";
export var oneLine = "_bg-l";
export var optionsButton = "_bg-n";
export var plus = "_bg-o";
export var portalButtonsWrapper = "_bg-g";
export var red = "_bg-p";
export var scrolledTop = "_bg-9";
export var search = "_bg-q";
export var selectedConversationsCount = "_bg-r";
export var spinner = "_bg-t";
export var strong = "_bg-u";
export var summaryCell = "_bg-v";
export var tableContainer = "_bg-11";
export var tagContainer = "_bg-w";
export var threeDots = "_bg-x";
export var twoLines = "_bg-y";
export var unread = "_bg-z";